import styled from "@emotion/styled";

import { commonColors } from "application/theme";

export const ModalStyled = styled("div")`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 32px 32px 0 0;
  background: ${commonColors.white};
`;

export const TopSection = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 12px 12px 16px;

  > h1 {
    color: ${commonColors.black};
    font-family: Unica77;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
`;

export const CloseButton = styled("button")`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;

  > svg {
    width: 24px;
    height: 24px;
  }
`;

export const Content = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  padding: 4px 16px 24px 16px;
`;

export const DealInfo = styled("div")`
  display: flex;
  align-items: center;
  gap: 16px;

  > img {
    width: 90px;
    height: 95px;
    border-radius: 8px;
  }

  > p {
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
  }
`;

export const ConditionsList = styled("ol")`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: decimal;
  list-style-position: inside;
  list-style-type: decimal;
  margin-block-start: 0px;
  margin-block-end: 0px;
  padding-inline-start: 0px;

  > li {
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;

    &::marker {
      font-weight: 500;
    }

    > span {
      font-weight: 500;
    }
  }
`;

export const BottomSection = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 16px 24px 16px;
`;

export const LinkSection = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-radius: 18px;
  background: ${commonColors.white};
  box-shadow: 0 4px 10px 0 rgba(26, 40, 104, 0.1);
`;

export const LinkInfo = styled("div")`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  > h2 {
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
  > p {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;
  }
`;

export const LinkButtons = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;

  > button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 110px;
    background-color: ${commonColors.grey900};

    > svg {
      width: 22px;
      height: 22px;
    }

    &.copy-button {
      background-color: ${commonColors.blue700};

      &.active {
        background-color: ${commonColors.green700};
      }
    }
  }
`;
